import { css } from "@emotion/react";

export const catalogSearch = css`
  display: flex;
  position: relative;
  flex: 1;
`;

export const skeletonButton = css`
  box-sizing: content-box;
  margin-left: 1rem;
  margin-right: 1rem;
  width: 30%;
`;

export const skeletonSubButton = css`
  box-sizing: content-box;
  margin-left: 2rem;
  margin-right: 2rem;
  width: 100%;
`;

export const skeletonLineItem = css`
  position: relative;
  display: flex;
`;
